<template>
  <div class="productinfo-page">
    <div class="mainInfo-part1" v-if="prductData.productPicList">
      <div class="zhezhaoceng"></div>
      <img v-if="isEn == '0'" :src="prductData.productPicList[0].picUrl" alt="产品图" style="width:100%;">
      <img v-if="isEn == '1'" :src="prductData.productPicList[0].picUrl" alt="chanpintu" style="width:100%;">
      <div class="mainInfo-part1-title">
        <div class="mainInfo-part1-title1">{{prductData.productPicList[0].title}}</div>
        <!-- <div class="mainInfo-part1-title2"></div> -->
        <pre class="mainInfo-part1-title3">{{prductData.productPicList[0].content}}</pre>
      </div>
    </div>

    <div class="row mainInfo-part2">
      <div class="col-md-3 mainInfo-part2-left" v-if="isEn == '0'">产品简介</div>
      <div class="col-md-3 mainInfo-part2-left" v-if="isEn == '1'">Product introduction</div>
      <div class="col-md-9 mainInfo-part2-right">
        <pre class="mainInfo-part2-right-top" v-html="prductData.productPicList[1].content"></pre>
        <div class="mainInfo-part2-right-bottom hover-common" v-if="prductData.productPicList[1].picUrl" @click="openVideoShow()">
          <span class="el-icon-video-play" style="font-size:28px;"></span>
          <span v-if="isEn == '0'">观看产品视频</span>
          <span v-if="isEn == '1'">Watch product videos</span>
        </div>
      </div>
    </div>

    <div class="mainInfo-part3" v-if="prductData.productPicList[2].picUrl && isEn == '0'">
      <img :src="prductData.productPicList[2].picUrl" alt="产品特点" :style="{'width':'100%','min-height':has_showOrder()?'600px':'auto'}">
      <div class="mainInfo-part3-title" v-if="has_showOrder()">产品特点</div>
      <div class="mainInfo-part3-content clearfix">
        <div class="mainInfo-part3-content-list" v-for="(item,index) in prductData.productPicList" :key="index" v-if="item.showOrder.toString().indexOf('A')>-1">
          <div class="mainInfo-part3-content-list-icon">
            <img v-if="item.picUrl" :src="item.picUrl" alt="产品特点" style="width: 100%;">
          </div>
          <div class="mainInfo-part3-content-list-desc">
            <div style="max-width:300px;margin:0 auto;text-align:center">{{item.title}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mainInfo-part3" v-if="prductData.productPicList[2].picUrl && isEn == '1'">
      <img :src="prductData.productPicList[2].picUrl" alt="Characteristic" :style="{'width':'100%','min-height':has_showOrder()?'600px':'auto'}">
      <div class="mainInfo-part3-title" v-if="has_showOrder()">Characteristic</div>
      <div class="mainInfo-part3-content clearfix">
        <div class="mainInfo-part3-content-list" v-for="(item,index) in prductData.productPicList" :key="index" v-if="item.showOrder.toString().indexOf('A')>-1">
          <div class="mainInfo-part3-content-list-icon">
            <img v-if="item.picUrl" :src="item.picUrl" alt="chanpintedian" style="width: 100%;">
          </div>
          <div class="mainInfo-part3-content-list-desc">
            <div style="max-width:300px;margin:0 auto;text-align:center">{{item.title}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mainInfo-part4" v-for="(item,index) in prductData.productPicList" :key="index" v-if="item.showOrder.toString().indexOf('B')>-1" >
      <img v-if="isEn == '0'" :src="item.picUrl" alt="产品介绍" style="width:100%;">
      <img v-if="isEn == '1'" :src="item.picUrl" alt="Product introduction" style="width:100%;">
      <div :class="[comp0(item.showOrder)?'mainInfo-content-right':'mainInfo-content-left']" style="">
        <pre :class="[comp0(item.showOrder)?'mainInfo-title-white':'mainInfo-title-black']" v-html="item.title"></pre>
        <pre :class="[comp0(item.showOrder)?'mainInfo-desc-white':'mainInfo-desc-black']" v-html="item.content"></pre>
      </div>
    </div>

    <div class="mainInfo-part6 col-md-90">
         <ProductParameter :parameter = "prductData.productParamList" :productCase = "prductData.productInfo.productCase" ></ProductParameter>
    </div>
    <!-- <videoCommon ref="videoProp" @cqqclick="clickChange" :videoTitle="videoTitle" :videoUrl = "videoUrl"></videoCommon> -->
      <videoCommon ref="videoProp" v-if="prductData.productPicList[1].picUrl" :videoTitle="''" :videoUrl = "prductData.productPicList[1].picUrl"></videoCommon>
  </div>
</template>


<script>
// import { productList } from "@/views/productList.js";
import ProductParameter from "@/components/ProductParameter";
import videoCommon from "@/components/videoCommon";
export default {
  name: "productinfoA",
  components: {
    ProductParameter,
    videoCommon
  },
  data() {
    return {
      prductMSG: {info:{productIntroduceDesc:""}}, //产品信息
      activetab:"",
      parameter: "", //参数
      videoUrl:'',
      videoTitle:'',
      prductData:{
        productInfo: {
          productCase: ""
        },
        productPicList:[{
          title:"",
          content:"",
          picUrl:"",
          showOrder:""
        },{
          title:"",
          content:"",
          picUrl:"",
          showOrder:""
        },{
          title:"",
          content:"",
          picUrl:"",
          showOrder:""
        }]
      },
      isEn: '0',
    };
  },
  created() {
    this.isEn = ('1' ==sessionStorage.getItem("isEn")? sessionStorage.getItem("isEn") : '0');
  },
  methods:{
     openVideoShow(){
      this.$refs.videoProp.openVideoShow();
    },
    closeVideoShow(){
      this.$refs.videoProp.closevideoShow();
    },
    changetab(){

      if(this.activetab==this.prductMSG.info.productContent_IMG3_imgtab1){
        this.activetab=this.prductMSG.info.productContent_IMG3_imgtab2;
      }else{
         this.activetab=this.prductMSG.info.productContent_IMG3_imgtab1;
      }
    }

  },
  mounted() {
    let productNUM = this.$route.params.id;
    // productList && productList.forEach(element => {
    //     element.children.forEach(item => {
    //       if (item.value == productNUM) {
    //         debugger
    //         this.prductMSG = item;
    //         this.parameter = Object.assign({parameter:item.info.parameter},{DataDownload:item.info.DataDownload},{case:item.info.case});
    //         this.videoUrl = item.info.productVIDEO;
    //         this.videoTitle = item.label;
    //         this.activetab =  item.info.productContent_IMG3_imgtab1;
    //       }
    //     });
    //   });
      //  获取 详细信息  /api/product/getRelateInfoByProductUuid/217dc69b-9818-43e0-a253-3ebe274deac2
      axios.post(`${window.$server_config.VUE_APP_WEBSITE_API}outer/product/getDetailInfo/${productNUM}`,{}
      ).then((response)=>{
        var res=response.data
          if(res.code== 200){
              this.prductData = res.data;
          }
      }).catch(res => {

      })

  },
  updated(){
  },
  computed:{
    comp0(){
      return function(num){
        let newnum = num.split("B")[1]
        return !(newnum%2==0);
      }
    },
    has_showOrder(){
      return function(){
        let result = this.prductData.productPicList.find(item=>item.showOrder=="A0");
        return result&&result.picUrl
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clearfix:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.productinfo-page {
  margin-top: 65px;
}
.mainInfo-part1 {
  height: auto;;
  width: 100%;
  position: relative;
  /* background: url("../assets/img/Homeabout2.png") no-repeat;
  background-size: 100% 100%; */
}
.zhezhaoceng{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.1;
  background: #000;
}
.mainInfo-part1-title{
  position: absolute;
  width: 100%;
  top: 50%;
  /* left: 50%; */
  margin-top:-82px;
  text-align: center;
}
.mainInfo-part1-title1 {
  font-size: 58px;
  color: #ffffff;
  font-weight: 600;
  margin-bottom: 8px;
}
.first-page-titledesc1{
    font-size: 22px;
    font-weight: normal;
}
.mainInfo-part1-title2 {
  width:80px;
  margin:18px auto;
  border-bottom: 4px solid #fff;
}
.mainInfo-part1-title3 {
  font-size: 28px;
  color: #ffffff;
}
.mainInfo-part2 {
  background: #ffffff;
  max-width: 1200px;
  min-width: 800px;
  margin:0 auto;
  padding: 128px 80px 143px 80px;
}
.mainInfo-part2-left {
  font-size: 32px;
  color: #2c2c2c;
  font-weight: 600;
}
.mainInfo-part2-right {
  height: 100%;
}
.mainInfo-part2-right-top {
  font-size: 16px;
  color: #2c2c2c;
  margin-bottom: 30px;
  line-height: 32px;
  white-space: pre-wrap;
  word-wrap: break-word;
  /* white-space: pre-line; */
}
.mainInfo-part2-right-bottom {
  font-size: 16px;
  color: #00BBF8;
  cursor: pointer;
  width: fit-content;
}
.mainInfo-part2-right-bottom span {
  display: inline-block;
  vertical-align: middle;
}
.mainInfo-part3 {
  width: 100%;
  margin: 0 auto;
  color: #ffffff;
  position: relative;
}
.mainInfo-part3-title {
  font-weight: 600;
  font-size: 32px;
  text-align: center;
  position: absolute;
  left: 51%;
  top: 60px;
  margin-left: -80px;
}
.mainInfo-part3-content {
  /* width: 100%; */
  /* max-width: 1200px; */
  min-width: 800px;
  width: 80%;
  margin: 0 auto;
  /* padding:0 20px; */
  position: absolute;
  top: 27%;
  left: 10%;
}
.mainInfo-part3-content-list {
  width: 33.3333%;
  float: left;
  height:130px;
  margin-bottom: 75px;
  padding: 0 20px;
}
.mainInfo-part3-content-list:nth-child(3n + 1) {
  padding-left: 0px;
}
.mainInfo-part3-content-list:nth-child(3n + 3) {
  padding-right: 0px;
}
.mainInfo-part3-content-list-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 24px;
}
.mainInfo-part3-content-list-icon span {
  font-size: 80px;
}
.mainInfo-part3-content-list-desc {
  font-size: 16px;
  margin: 0 auto;
}

.mainInfo-part4 {
  width: 100%;
  /* height: 736px; */
  color: #ffffff;
  position: relative;
  /* background-image: linear-gradient(-138deg, #121212 0%, #393939 100%); */
}

.mainInfo-left-content{
  /* max-width: 1200px; */
  min-width: 1000px;
  width: 80%;
  height:100%;
  /* margin: 0 auto; */
  padding: 0 20px;
  position: absolute;
  right: 15%;
  top: 0;

}
.mainInfo-content-left{
  position:absolute;
  left:15%;
  top:30%;
  text-align:left;
}
.mainInfo-content-right{
  position:absolute;
  right:15%;
  top:30%;
  text-align:right;
}
.mainInfo-title-white{
  font-size: 48px;
  color: #ffffff;
  font-weight: 600;
  line-height: 66px;
  /* margin-top: 56%; */
}
.mainInfo-title-black{
  font-size: 48px;
  color: #1C1C1C;
  font-weight: 600;
  line-height: 66px;
  /* margin-top: 56%; */
}
.mainInfo-title-orange{
  font-size: 48px;
  color: #E38A62;
  font-weight: 600;
  line-height: 66px;
  /* margin-top: 56%; */
}
.mainInfo-desc-white{
  width:100%;
  font-size: 20px;
  color: #ffffff;
  margin-top:12px;
  /* line-height: 30px!important; */
}
.mainInfo-desc-black{
  width:100%;
  font-size:20px;
  color: #898989;
  margin-top:12px;
}
.mainInfo-desc-orange{
  width:100%;
  font-size: 20px;
  color: #E5BCA9;
  margin-top:12px;
}
.mainInfo-desc-white p,.mainInfo-desc-black p,.mainInfo-desc-orange p{
  line-height: 30px !important;
}
.mainInfo-part4-title {
  font-size: 48px;
  height: 48px;
  line-height: 50px;
  margin-top: 285px;
  margin-top: calc(50% + 90px);
}
.mainInfo-part4-desc {
  font-size: 18px;
  width: 100%;
  margin-top:36px;
}
/* .mainInfo-left-content-right{
  float: right;
  width: 700px;
  height: 100%;
} */

.mainInfo-part5 {
  width: 100%;
  position: relative;
  /* padding: 300px 320px 0 0; */
  background: #000;
}
.mainInfo-part5-tab{
  position: absolute;
  /* text-align: center; */
  top: -10%;
  right:0;
  text-align: right;
  cursor: pointer;
  border-bottom:0.5px solid rgba(248, 248, 248, 0.5);
}
.mainInfo-part5-tab-left{
  margin: 0 auto;
  float: right;
  padding: 10px 20px;
}
.mainInfo-part5-tab-right{
  margin: 0 auto;
  float: right;
  padding: 10px 20px;
}
.mainInfo-part5-tab-white{
  font-size: 18px;
  color:rgba(255, 255, 255,0.7);
}
.mainInfo-part5-tab-black{
  font-size: 18px;
  color: #ffffff;
}
.mainInfo-part5-tab-organge{
  font-size: 18px;
  color: #ffffff;
}
.mainInfo-part5-tabactive{
  border-bottom: 2px solid #fff;
  color: #ffffff;
}

.mainInfo-right-content {
    width: 80%;
    min-width: 500px;
    text-align: left;
    position: absolute;
    top: 50%;
    left: 15%;
    margin-top: -90px;
}

.col-md-90{
  margin: 0 auto;
}
.hover-common:hover{
  color: #1063ca;
}
.product_animation_img{
  -webkit-animation-name: fadeInOut;
  -webkit-animation-timing-function:linear;
  -webkit-animation-duration: 0.7s;
}
 @-webkit-keyframes fadeInOut {
   0% {
       opacity:0.3;
    }
   /* 20% {
       opacity:0.5;
   }
  40% {
       opacity:0.7;
   }
   60% {
       opacity: 0.85;
   } */
   80% {
       opacity:1;
   }
}
.product_normal_img{
  -webkit-animation-name: fadeIn;
  -webkit-animation-timing-function:linear;
  -webkit-animation-duration: 0.7s;
}
 @-webkit-keyframes fadeIn {
    0% {
       opacity:0.3;
    }
   /* 20% {
       opacity:0.5;
   }
  40% {
       opacity:0.7;
   }
   60% {
       opacity: 0.85;
   } */
   80% {
       opacity:1;
   }
}
@media only screen and (max-width:1500px){
  .mainInfo-content-left{
    left: 10%;
  }
  .mainInfo-content-right{
     right: 10%;
  }
}

/* 中屏适应性 */
@media only screen and (min-width:1200px){
    .mainInfo-right-content{
      right: 15%;
    }
    .mainInfo-left-content{
      left: 15%;
    }
}
/* 笔记本适应性 */
@media only screen and (max-width:1200px){
    .mainInfo-right-content{
        right: 5%;
    }
    .mainInfo-left-content{
      left: 5%;
    }
}


</style>



// WEBPACK FOOTER //
// src/views/productinfoA.vue